<h1 mat-dialog-title>{{ 'TITLE' | translate }}</h1>

<mat-dialog-content>
  <div fxLayout="column">
    <ng-container *ngFor="let file of invoiceFiles">
      <div class="h-50" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
        <div *ngIf="!file.status" fxFlex="24px">
          <mat-icon>arrow_right</mat-icon>
        </div>
        <div *ngIf="file.status === DocumentStatus.REJECTED"
             [matTooltip]="'allegato rifiutato'"
             fxFlex="24px">
          <mat-icon color="warn">warning</mat-icon>
        </div>
        <div *ngIf="file.status === DocumentStatus.ACCEPTED"
             [matTooltip]="'allegato accettato'"
             fxFlex="24px">
          <mat-icon>check</mat-icon>
        </div>

        <div fxFlex="230px">
          <span>{{ 'OTHER_DOC.' + file.attachmentType | translate }}</span>
          <ng-container *ngIf="file.attachmentType === AttachmentType.other && file.otherDocumentNotes">
            <span>&nbsp;-&nbsp;{{ file.otherDocumentNotes }}</span>
          </ng-container>
        </div>

        <div class="text-truncate" fxFlex fxLayoutAlign="end" style="padding-right: 8px">
          <a (click)="viewAttachment(uuid, file.id)" style="cursor: pointer">
            <span>{{ file.name }}</span>
          </a>
        </div>

        <input #fileInputEditAttachment
               (change)="editAttachment($event, file.id, file.attachmentType)"
               [accept]="file.attachmentType === AttachmentType.xml_invoice ? '.xml' : ''"
               hidden
               type="file" />

        <button (click)="fileInputEditAttachment.click()"
                [disabled]="file.status === DocumentStatus.ACCEPTED"
                color="primary"
                mat-icon-button>
          <mat-icon>cloud_upload</mat-icon>
        </button>
      </div>
    </ng-container>
  </div>
  <p></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="closeDialog()"
          [disabled]="uploadingAttachment"
          class="btn-close"
          color="accent"
          fxLayoutAlign="center center"
          mat-button>
    <span *ngIf="!uploadingAttachment"> {{ 'ACTION.CLOSE' | translate }}</span>
    <span *ngIf="uploadingAttachment">
        <mat-progress-spinner
          [diameter]="18"
          color="primary"
          mode="indeterminate"
        ></mat-progress-spinner>
      </span>
  </button>
</mat-dialog-actions>
